import React, { useState, useEffect } from 'react';
import {
  Box,
  Stack,
  Flex,
  InputGroup,
  Input,
  InputRightElement,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Portal,
} from '@chakra-ui/react';
import { BiEdit, BiMessageDetail } from 'react-icons/bi';
import { CiSearch } from 'react-icons/ci';
import { CiFilter } from 'react-icons/ci';
import { MdSchedule } from 'react-icons/md';

import NewRoomSearchDialog from './NewRoomSearchDialog';
import AutomatedMessagesDialog from './AutomatedThreadDialog';

import { useDispatch } from 'react-redux';
import { getAllRooms } from '../../redux/actions/conversationActions';

const SearchBar = () => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [isAutoOpen, setIsAutoOpen] = useState(false);
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');

  const handleFilter = (value) => {
    setFilter(value);
    dispatch(getAllRooms(1, value, search));
  };

  const handleSearch = (value) => {
    setSearch(value);
    dispatch(getAllRooms(1, filter, value));
  };

  useEffect(() => {
    dispatch(getAllRooms(1, filter, search));
  }, [filter, search]);

  return (
    <Box>
      <Stack>
        <Flex py={3} mx={2}>
          <InputGroup>
            <Input
              placeholder="Search Message"
              fontSize={14}
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
              color="#FFF"
              border="solid 1px #E3E3E3"
              _focus={{ boxShadow: 'none', border: 'solid 1px #E3E3E3' }}
              borderRadius="xl"
            />
            <InputRightElement>
              <CiSearch color="green.500" fontSize={22} />
            </InputRightElement>
          </InputGroup>

          <Menu>
            <MenuButton
              as={Button}
              border="solid 1px #E3E3E3"
              color="inherit"
              borderRadius="xl"
              px={1}
              mx={2}
              _hover={{ color: 'white', background: 'orange.primary' }}
              cursor="pointer"
            >
              <CiFilter fontSize={25} />
            </MenuButton>
            <Portal>
              <MenuList>
                <MenuItem value="all" onClick={() => handleFilter('all')}>
                  All
                </MenuItem>
                <MenuItem value="unread" onClick={() => handleFilter('unread')}>
                  Unread
                </MenuItem>
                <MenuItem
                  value="starred"
                  onClick={() => handleFilter('starred')}
                >
                  Starred
                </MenuItem>
                <MenuItem value="dnd" onClick={() => handleFilter('dnd')}>
                  Do Not Disturb
                </MenuItem>
              </MenuList>
            </Portal>
          </Menu>

          <Button
            border="solid 1px #E3E3E3"
            color="inherit"
            borderRadius="xl"
            px={1}
            _hover={{ color: 'white', background: 'orange.primary' }}
            cursor="pointer"
            onClick={() => setIsOpen(true)}
          >
            <BiEdit fontSize={20} />
          </Button>
          <Button
            border="solid 1px #E3E3E3"
            color="inherit"
            borderRadius="xl"
            px={1}
            ml={2}
            _hover={{ color: 'white', background: 'orange.primary' }}
            cursor="pointer"
            onClick={() => setIsAutoOpen(true)}
          >
            <MdSchedule fontSize={20} />
          </Button>
        </Flex>
      </Stack>
      <NewRoomSearchDialog isOpen={isOpen} onClose={() => setIsOpen(false)} />
      <AutomatedMessagesDialog
        isOpen={isAutoOpen}
        onClose={() => setIsAutoOpen(false)}
      />
    </Box>
  );
};

export default SearchBar;
